var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0926 0H10.0885C4.51676 0 0 4.49641 0 10.043V29.957C0 35.5036 4.51676 40 10.0885 40H30.0926C35.6643 40 40.1811 35.5036 40.1811 29.957V10.043C40.1811 4.49641 35.6643 0 30.0926 0Z",
    fill: "#C49261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9776 32.1956L11.5209 31.4826C10.9329 31.4049 10.4897 30.9056 10.4897 30.3146V17.378C10.4897 16.7871 10.9301 16.2877 11.5209 16.21L18.3153 15.3223V31.0276C18.3153 31.7406 17.6854 32.2899 16.9776 32.1956Z",
    fill: "#022426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7382 8.86663L29.2092 14.0352C29.2733 14.726 28.7271 15.3197 28.0304 15.3197H18.3181L18.9061 8.86663C18.9619 8.25905 19.4719 7.79297 20.085 7.79297H27.5622C28.1753 7.79297 28.6853 8.25905 28.741 8.86663H28.7382Z",
    fill: "#022426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.6821727bfbe84fba884d1aab5f0d3073.svg";
export { ForwardRef as ReactComponent };